import { useIntl } from 'react-intl';
import { X } from 'lucide-react';

import Button from '../../../shared/ui/button/button';

import styles from './sign-up-form.module.css';

export const MfaModal = ({ mfa }) => {
	const intl = useIntl();
	const t = id => intl.formatMessage({ id });
	const { mfaData, codeInputs, code, error, isLoading } = mfa;

	return (
		<div className={styles.mfaModal}>
			<div className={styles.mfaModalContent}>
				<div className={styles.mfaModalHeader}>
					<h3 className={styles.mfaModalTitle}>{t('SignUpId22')}</h3>
					<button
						type='button'
						className={styles.mfaModalClose}
						onClick={mfa.close}
						disabled={isLoading}
						aria-label='Close'
					>
						<X size={20} />
					</button>
				</div>
				<h4 className={styles.mfaModalSubtitle}>{t('SignUpId23')}</h4>
				<p className={styles.mfaModalDescription}>
					{mfaData.mfa_type === 'email' ? t('SignUpId24') : t('SignUpId25')}
				</p>
				<div className={styles.codeInputContainer}>
					{codeInputs.map((value, index) => (
						<input
							key={index}
							id={mfa.inputId(index)}
							type='text'
							inputMode='numeric'
							maxLength={1}
							value={value}
							onChange={e => mfa.handleInputChange(index, e.target.value)}
							onKeyDown={e => mfa.handleKeyDown(index, e)}
							onPaste={mfa.handlePaste}
							className={styles.codeInput}
							autoFocus={index === 0}
						/>
					))}
				</div>
				{mfaData.mfa_type !== 'email' && (
					<p className={styles.mfaCodeInfo}>{t('SignUpId26')}</p>
				)}
				{error && <span className={styles.mfaErrorText}>{error}</span>}
				<div className={styles.mfaModalButtons}>
					<Button
						fullWidth
						onClick={mfa.verify}
						disabled={isLoading || code.length !== 6}
					>
						{isLoading ? t('SignUpId27') : t('SignUpId28')}
					</Button>
					<Button
						variant='secondary'
						fullWidth
						onClick={mfa.close}
						disabled={isLoading}
					>
						{t('SignUpId29')}
					</Button>
				</div>
			</div>
		</div>
	);
};
